import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { MapPin, Phone, Mail, Instagram, Facebook } from 'lucide-react';

const FooterContainer = styled.footer`
  background: white;
  color: #333;
  padding: 60px 0 30px;
  border-top: 1px solid #e0e0e0;
`;

const FooterContent = styled.div`
  width: 100%;
  padding: 0 20px;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
`;

const FooterSection = styled.div`
  h3 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 20px;
    color: #333;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: 10px;
  }

  a {
    color: #333;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #666;
    }
  }
`;

const ContactInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  color: #333;

  svg {
    color: #333;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 20px;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: white;
  border: 2px solid #333;
  border-radius: 50%;
  color: #333;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    background: #333;
    color: white;
  }
`;

const FooterDescription = styled.p`
  color: #333;
  line-height: 1.6;
`;

const FooterBottom = styled.div`
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
  color: #666;
  font-size: 14px;
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterGrid>
          <FooterSection>
            <h3>SARAYLI MODA</h3>
            <FooterDescription>
              Hayalinizdeki gelinliği bulmanız için buradayız. 
              Özel tasarım gelinliklerimizle düğününüzün en güzel anını yaşayın.
            </FooterDescription>
            <SocialLinks>
              <SocialLink href="https://www.instagram.com/saraylimoda">
                <Instagram size={20} />
              </SocialLink>
              <SocialLink href="#">
                <Facebook size={20} />
              </SocialLink>
            </SocialLinks>
          </FooterSection>

          <FooterSection>
            <h3>Koleksiyonlar</h3>
            <ul>
              <li><a href="/gelinlikler">2026 Imperial Koleksiyonu</a></li>
              <li><a href="/gelinlikler">2026 Elegance Koleksiyonu</a></li>
              <li><a href="/gelinlikler">2026 Vintage Koleksiyonu</a></li>
              <li><a href="/gelinlikler">Özel Tasarım Gelinlikler</a></li>
              <li><a href="/gelinlikler">Haute Couture</a></li>
            </ul>
          </FooterSection>

          <FooterSection>
            <h3>Kategoriler</h3>
            <ul>
              <li><a href="/gelinlikler">A Kesim Gelinlikler</a></li>
              <li><a href="/gelinlikler">Balık Kesim Gelinlikler</a></li>
              <li><a href="/gelinlikler">Prenses Model Gelinlikler</a></li>
              <li><a href="/gelinlikler">Bohem Gelinlikler</a></li>
              <li><a href="/gelinlikler">Tesettür Gelinlikler</a></li>
            </ul>
          </FooterSection>

          <FooterSection>
            <h3>Yardım</h3>
            <ul>
              <li><Link to="/teslimat-iade">Teslimat ve İade Şartları</Link></li>
              <li><Link to="/gizlilik">Gizlilik Sözleşmesi</Link></li>
              <li><Link to="/mesafeli-satis">Mesafeli Satış Sözleşmesi</Link></li>
            </ul>
          </FooterSection>

          <FooterSection>
            <h3>İletişim</h3>
            <ContactInfo>
              <MapPin size={16} />
              <span>İstanbul, Türkiye</span>
            </ContactInfo>
            <ContactInfo>
              <Phone size={16} />
              <span>0224 221 51 20</span>
            </ContactInfo>
            <ContactInfo>
              <Mail size={16} />
              <span>info@saraylimoda.com</span>
            </ContactInfo>
          </FooterSection>
        </FooterGrid>

        <FooterBottom>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px', marginBottom: '20px' }}>
            <img src="/iyzico-footer.png" alt="İyzico" style={{ height: '40px' }} />
          </div>
          <p>&copy; 2026 Saraylı Moda. Tüm hakları saklıdır.</p>
        </FooterBottom>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
